export function authErrorMessage(cause: unknown): string {
  const code = errorCode(cause);
  if (errorStatus(cause) === 429) {
    return "Too many attempts. Wait a moment and try again.";
  }
  if (code === "INVALID_EMAIL_OR_PASSWORD") {
    return "That email and password combination is not valid.";
  }
  if (code === "EMAIL_NOT_VERIFIED") {
    return "Verify your email address before signing in.";
  }
  if (code === "INVALID_PASSWORD") {
    return "Your current password is not correct.";
  }
  if (code === "PASSWORD_TOO_SHORT") {
    return "Use at least 8 characters.";
  }
  if (code === "PASSWORD_TOO_LONG") {
    return "Use no more than 256 characters.";
  }
  if (code === "SESSION_NOT_FRESH") {
    return "Sign in again before changing your authentication methods.";
  }
  if (code === "SESSION_EXPIRED") {
    return "Sign in again before deleting your Account.";
  }
  if (code === "ACCOUNT_DELETION_INCOMPLETE") {
    return "Account deletion could not finish. Retry or use the manual erasure path.";
  }
  if (code === "EMAIL_CHANGE_CONFLICT") {
    return "This email change cannot be completed. Your current email is unchanged.";
  }
  if (code === "EMAIL_CHANGE_NOT_PENDING") {
    return "That email change is no longer active. Start again.";
  }
  if (code === "EMAIL_CHANGE_UNAVAILABLE") {
    return "Email changes are temporarily unavailable. Your current email is unchanged.";
  }
  if (code === "PASSWORD_ALREADY_SET") {
    return "This Account already has a password.";
  }
  if (code === "BROWSER_SESSION_NOT_FOUND") {
    return "That browser session is no longer active.";
  }
  if (code === "CURRENT_SESSION_CANNOT_BE_REVOKED") {
    return "Use the main sign-out control to end this browser session.";
  }
  if (code === "PASSWORD_RECOVERY_UNAVAILABLE") {
    return "Password recovery is temporarily unavailable. Please try again.";
  }
  if (typeof cause === "object" && cause !== null && "message" in cause) {
    const message = cause.message;
    if (typeof message === "string" && message.length > 0) return message;
  }
  return "Authentication could not be completed.";
}

function errorStatus(cause: unknown): number | undefined {
  if (typeof cause !== "object" || cause === null) return undefined;
  const record = cause as Record<string, unknown>;
  for (const field of ["status", "statusCode"] as const) {
    const value = record[field];
    if (typeof value === "number") return value;
  }
  return undefined;
}

export function errorCode(cause: unknown): string | undefined {
  return typeof cause === "object" &&
    cause !== null &&
    "code" in cause &&
    typeof cause.code === "string"
    ? cause.code
    : undefined;
}
